var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-content', {
    staticClass: "pa-4"
  }, [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('sales-dashboard-table', {
    ref: "daily",
    attrs: {
      "mode": _vm.NSHOP_STATISTICS_MODES.DAILY.value
    },
    on: {
      "success": _vm.searchRest
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('sales-dashboard-table', {
    ref: "weekly",
    attrs: {
      "mode": _vm.NSHOP_STATISTICS_MODES.WEEKLY.value,
      "idle-text": _vm.IDLE_TEXT
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('sales-dashboard-table', {
    ref: "monthly",
    attrs: {
      "mode": _vm.NSHOP_STATISTICS_MODES.MONTHLY.value,
      "idle-text": _vm.IDLE_TEXT
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }